import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
import { Header } from '../Header';
import { Footer } from '../Footer';
import CrmCaseDo from "./CrmCaseDo";
import SendSms from "../Crm/SendSms";
import SelectAsync from 'react-select/async';

export default class CrmCaseList extends Base {
    constructor(props) {
        super(props);
        this.state = {
            controllerName: 'crm/case',
            data: null,
            loading: true,
            filters: {
                teamId: this.defaultGuid(),
                sourceId: this.defaultGuid(),
                blacklist: props.Blacklist,
                archived: props.Archived,
                mobile: '',
            },
            systemModuleId: 25,
            moduleAccessStatus: 1,
            page: 1,
            per_page: 30,
            phrase: '',
            mobile: ''
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    componentWillUnmount() {
        this.removeKeyDown();
    }
    componentDidMount() {
        this.httpPost("api/v1/common/check/module/access", {
            systemModuleId: this.state.systemModuleId
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.moduleAccessStatus = data.status;

                this.refreshData();
            });
    }
    componentWillReceiveProps(props) {
        if (props.Blacklist == this.state.filters.blacklist && props.Archived == this.state.filters.archived) return;
        this.state.filters.blacklist = props.Blacklist;
        this.state.filters.archived = props.Archived;
        this.refreshData();
    }
    onEdit(id) {
        this.removeKeyDown();
        this.showComponents({
            component: <CrmCaseDo Caller={this} Id={id} CrmCaseLogType={1} />
        });
    }
    sendSms() {
        this.removeKeyDown();
        this.httpPost("api/v1/" + this.state.controllerName + "/list", {
            page: this.state.page,
            count: this.state.per_page,
            phrase: this.state.phrase,
            filters: this.state.filters,
            mobileList: true
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    var mobiles = [];
                    data.records.forEach(item => {
                        if (!this.isEmpty(item.phone)) {
                            mobiles.push(item.phone);
                        }
                    });
                    this.showComponents({
                        component: <SendSms Mobiles={mobiles} Caller={this} UseIn={'crm'} CrmTeams={''} />
                    });
                }
                this.setState({
                    loading: false
                });
            })
    }
    renderForm() {
        if (this.state.moduleAccessStatus <= 0) return this.renderSystemModuleModuleAccessMessage(this.state.moduleAccessStatus);

        return <div>
            <div className="nk-content-body">
                <div className="nk-block-head nk-block-head-sm">
                    <div className="nk-block-between">
                        <div className="nk-block-head-content">
                            {this.state.filters.archived && <h3 className="nk-block-title page-title">فهرست پیگیریهای بایگانی شده</h3>}
                            {this.state.filters.blacklist && <h3 className="nk-block-title page-title">فهرست پیگیریهای بلک لیست</h3>}
                            <div className="nk-block-des text-soft">
                                <p>{this.money(this.state.data.recordsCount)} پیگیری یافت شد</p>
                            </div>
                        </div>
                        <div className="nk-block-head-content">
                            <div className="toggle-wrap nk-block-tools-toggle">
                                <a href="#" className="btn btn-icon btn-trigger toggle-expand me-n1" data-target="pageMenu"><em className="icon ni ni-menu-alt-r"></em></a>
                                <div className="toggle-expand-content" data-content="pageMenu">
                                    <ul className="nk-block-tools g-3">
                                        <li><a onClick={e => this.sendSms()} className="hand btn btn-warning">ارسال پیامک</a></li>
                                        <li>
                                            <a onClick={e => this.refreshData(e, "list", "excel")} className="hand btn btn-success"><span>دانلود اکسل</span></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="nk-block">
                    <div className="card card-bordered card-stretch">
                        <div className="card-inner-group">
                            <div className="card-inner position-relative card-tools-toggle">
                                <div className="card-title-group">
                                    <form className="card-tools" mthod="post" onSubmit={e => this.refreshData(e)}>
                                        <div className="form-inline flex-nowrap gx-3">
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.phrase} onChange={e => this.state.phrase = e.target.value} placeholder="نام شخص" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <input type="text" defaultValue={this.state.filters.mobile} onChange={e => this.state.filters.mobile = e.target.value} placeholder="شماره شخص" className="form-control" />
                                            </div>
                                            <div className="form-wrap">
                                                <SelectAsync
                                                    style={{ "width": "100%" }}
                                                    defaultValue={null}
                                                    isMulti={false}
                                                    placeholder="انتخاب تیم"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadCrmTeamsOptions(inputValue, callback)}
                                                    onChange={e => this.state.filters.teamId = e.value}
                                                />
                                            </div>
                                            <div className="form-wrap">
                                                <SelectAsync
                                                    style={{ "width": "100%" }}
                                                    defaultValue={null}
                                                    isMulti={false}
                                                    placeholder="انتخاب سرنخ"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadCrmSourcesOptions(inputValue, callback)}
                                                    onChange={e => this.state.filters.sourceId = e.value}
                                                />
                                            </div>
                                            <div className="btn-wrap">
                                                <span className="d-none d-md-block"><button onClick={e => this.refreshData(e)} type="submit" className="btn btn-dim btn-outline-light hand"><em class="icon ni ni-search"></em> جستجو</button></span>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                            {this.state.data.recordsCount <= 0 ?
                                <div className="card-inner-group">
                                    <div className="example-alert">
                                        <div className="alert alert-pro alert-warning">
                                            <div className="alert-text">
                                                <h6>توجه</h6>
                                                <p>هیچ پیگیری یافت نشد</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="card-inner p-0">
                                    <div className="nk-tb-list nk-tb-ulist">
                                        <div className="nk-tb-item nk-tb-head">
                                            <div className="nk-tb-col text-center"><span className="sub-text">نام</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">شماره تماس</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">سرنخ</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">تیم</span></div>
                                            <div className="nk-tb-col text-center"><span className="sub-text">بروز رسانی</span></div>
                                        </div>
                                        {this.state.data.records.map((record, index) =>
                                            <div className="nk-tb-item">
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">
                                                        <a className="text-primary txt-bold hand" onClick={e => this.onEdit(record.id)} title="مشاهده">
                                                            {record.name}
                                                        </a>
                                                    </span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.phone}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.sourceName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.teamName}</span>
                                                </div>
                                                <div className="nk-tb-col">
                                                    <span className="sub-text text-center">{record.editDateString}</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            }
                            {this.createPaging()}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                <Header data={this.state.data} />,
                <div className="nk-content ">
                    <div className="container-fluid">
                        <div className="nk-content-inner">
                            {this.isEmpty(this.state.data.global.companies) ? this.renderNoCompanyRegister() : this.renderForm()}
                        </div>
                    </div>
                </div>,
                this.renderPopupComponent(),
                <Footer />
            ];
        return contents;
    }
}